import { render, staticRenderFns } from "./DetailEula.vue?vue&type=template&id=2898d91a"
import script from "./DetailEula.vue?vue&type=script&lang=js"
export * from "./DetailEula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports